import DefaultProfile from "../images/hungry_smile.png"

export function getProfileImageUrl(profileUrl?: string | null): string {
  const normalizedProfileUrl = profileUrl?.trim();
  if (!normalizedProfileUrl || normalizedProfileUrl === "/user/profile/") {
    return DefaultProfile;
  }

  const resolvedProfileUrl = normalizedProfileUrl.startsWith("/user/profile/")
    ? normalizedProfileUrl
    : normalizedProfileUrl.startsWith("http://") || normalizedProfileUrl.startsWith("https://")
      ? normalizedProfileUrl
      : normalizedProfileUrl.startsWith("/")
        ? normalizedProfileUrl
        : `/user/profile/${normalizedProfileUrl}`;

  const base = resolvedProfileUrl.startsWith("http://") || resolvedProfileUrl.startsWith("https://")
    ? resolvedProfileUrl
    : process.env.REACT_APP_SERVER_URL + resolvedProfileUrl;

  const cacheKey = resolvedProfileUrl.split('').reduce((acc, char) => {
    return (acc << 5) - acc + char.charCodeAt(0);
  }, 0);

  return `${base}?v=${cacheKey}`;
}
